var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-admin"},[_c('h1',[_vm._v("admin")]),_c('p',[_vm._v("here be global config")])])}]

export { render, staticRenderFns }